module.exports = __webpack_public_path__ + "img/julio-back-plate.17ede165.svg";